import React from "react";
import Image from "next/legacy/image";
import styles from "./banner_box.module.scss";
import { getAssets } from "@unisearch/helpers";

const BannerBox = (props) => {
  return (
    <div className={styles.image_wrapper}>
      <Image
        layout="responsive"
        width={1900}
        height={500}
        blurDataURL={getAssets("assets/images/study/country_placeholder.webp")}
        placeholder="blur"
        className={styles.featured_image}
        src={
          props?.image ||
          getAssets("assets/images/study/country_placeholder.webp")
        }
        alt={props?.alt || "University Cover Photo"}
      />

      <div className={styles.overlay}></div>
      <div className={styles.banner_info}>
        <span className={styles.title}> {props?.title}</span>
        <span className={styles.text}>
          {props?.university || 0}{" "}
          {props?.university > 1 ? "Universities" : "University"}
        </span>
        <span className={styles.text}>
          {props?.courses || 0} {props?.courses > 1 ? "Courses" : "Course"}
        </span>
      </div>
    </div>
  );
};

export default BannerBox;
